import { useState } from "react";
import { SUBSCRIBE_ENDPOINT } from "./config";
import { trackSubscribe } from "./analytics";

// Renders nothing until SUBSCRIBE_ENDPOINT is set in src/config.js.
const Subscribe = ({ where = "topic" }) => {
    const [email, setEmail] = useState("");
    const [state, setState] = useState("idle"); // idle | sending | done | error

    if (!SUBSCRIBE_ENDPOINT) return null;

    const submit = async (e) => {
        e.preventDefault();
        if (state === "sending") return;
        setState("sending");
        try {
            const res = await fetch(SUBSCRIBE_ENDPOINT, {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ email, source: where, page: window.location.pathname }),
            });
            if (!res.ok) throw new Error(res.status);
            setState("done");
            setEmail("");
            trackSubscribe(where);
        } catch (err) {
            setState("error");
        }
    };

    if (state === "done") {
        return (
            <div className="subscribe subscribe-done">
                <p>收到！有新練習上線會電郵通知你。</p>
            </div>
        );
    }

    return (
        <div className="subscribe">
            <h3>新練習上線通知</h3>
            <p>留低電郵，有新課題或試卷推出就會通知你。唔會發廣告，隨時可以取消。</p>
            <form onSubmit={submit}>
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    aria-label="電郵地址"
                />
                <button type="submit" disabled={state === "sending"}>
                    {state === "sending" ? "傳送中…" : "通知我"}
                </button>
            </form>
            {state === "error" && (
                <p className="subscribe-error">傳送唔到，請稍後再試，或者電郵去 mathexe0@gmail.com。</p>
            )}
        </div>
    );
}

export default Subscribe;
